import { createStitches } from '@stitches/react'
import localFont from '@next/font/local'

import colors from 'theme/colors'
import { media } from 'theme/breakpoints'
import utils from 'theme/utils'

const GeneralSans = localFont({
  src: [
    {
      path: '../public/assets/fonts/GeneralSans/GeneralSans-Medium.woff2',
      weight: '500',
      style: 'normal',
      display: 'swap',
      preload: true,
      fallback: ['sans-serif']
    },
    {
      path: '../public/assets/fonts/GeneralSans/GeneralSans-Medium.woff',
      weight: '500',
      style: 'normal',
      display: 'swap',
      preload: true,
      fallback: ['sans-serif']
    },
    {
      path: '../public/assets/fonts/GeneralSans/GeneralSans-Regular.woff2',
      weight: '400',
      style: 'normal',
      display: 'swap',
      preload: true,
      fallback: ['sans-serif']
    },
    {
      path: '../public/assets/fonts/GeneralSans/GeneralSans-Regular.woff',
      weight: '400',
      style: 'normal',
      display: 'swap',
      preload: true,
      fallback: ['sans-serif']
    },
  ],
})

export const DEFAULT_SIZE = 8
export const SITE_COLUMNS = 12

export const rem = (...values) => values.map(px => `${+px / (DEFAULT_SIZE * 2)}rem`).join(' ')

export const col = (colN) =>  `${(100 / 12) * colN}% `

export const {
  keyframes,
  styled,
  getCssText,
  globalCss,
  config,
} = createStitches({
  theme: {
    fonts: { base: GeneralSans.style.fontFamily },
    colors,
    fontSizes: {
      // Desktop font sizes
      'footer': rem(14),
      'sub-desk': rem(12),
      'p3-mid': rem(14),
      'p1-mid': rem(18),
      'p1': rem(18),
      'subtitle-2': rem(24),
      'subtitle-1': rem(32),

      'h3': rem(48),
      'h2': rem(64),
      'h1-mid': rem(80),
      'h1': rem(100),
      'sliding-txt': rem(200),
      'stats': rem(140),

      // Mobile font sizes
      'sub-2-mobile': rem(8),
      'sub-mobile': rem(8),
      'p3-mid-mobile': rem(10),
      'p2-mid-mobile': rem(12),
      'p2-mobile': rem(12),
      'p1-mid-mobile': rem(14),
      'p1-mobile': rem(14),
      'subtitle-2-mobile': rem(16),
      'subtitle-1-mobile': rem(18),
      'h3-mobile': rem(18),
      'h2-mobile': rem(32),
      'h1-mid-mobile': rem(40),
      'h1-mobile': rem(48),
      'sliding-txt-mobile': rem(100),
      'stats-mobile': rem(48),
    },
    lineHeights: {
      // Desktop line height sizes
      'footer': rem(16),
      'sub-desk': rem(16.2),
      'p3-mid': rem(18.9),
      'p1-mid': rem(24.3),
      'p1': rem(24.3),
      'subtitle-2': rem(32.4),
      'subtitle-1': rem(43.2),
      'h3': rem(65),
      'h2': rem(72),
      'h1-mid': rem(80),
      'h1': rem(120),
      'sliding-txt': '120%',
      'stats': rem(140),

      // Mobile font sizes
      'sub-2-mobile': rem(10.8),
      'sub-mobile': rem(10.8),
      'p3-mid-mobile': rem(13.5),
      'p2-mid-mobile': rem(16.2),
      'p2-mobile': rem(16.2),
      'p1-mid-mobile': rem(18.9),
      'p1-mobile': rem(18.9),
      'subtitle-2-mobile': rem(21.6),
      'subtitle-1-mobile': rem(24.3),
      'h3-mobile': rem(24.3),
      'h2-mobile': rem(38),
      'h1-mid-mobile': rem(48),
      'h1-mobile': rem(54),
      'sliding-txt-mobile': '125%',
      'stats-mobile': rem(48),
    },
    fontWeights: {
      1: 500,
      2: 400,
    },
    radii: {
      small: '70px',
      normal: '70px',
      big: '100px',
      round: '50%',
    },
    space: {
      0: rem(12),
      1: rem(DEFAULT_SIZE),
      2: rem(DEFAULT_SIZE * 2),
      3: rem(DEFAULT_SIZE * 3),
      4: rem(DEFAULT_SIZE * 4),
      5: rem(DEFAULT_SIZE * 5),
    },
    sizes: {
      0: rem(12),
      1: rem(DEFAULT_SIZE),
      2: rem(DEFAULT_SIZE * 2),
      3: rem(DEFAULT_SIZE * 3),
      4: rem(DEFAULT_SIZE * 4),
      5: rem(DEFAULT_SIZE * 5),
    }
  },
  media,
  utils,
})
